import { render } from "./PackageRow.vue?vue&type=template&id=6e0a688d&scoped=true&ts=true&lang=pug"
import script from "./PackageRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./PackageRow.vue?vue&type=script&lang=ts&setup=true"

import "./PackageRow.vue?vue&type=style&index=0&id=6e0a688d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0a688d"]])

export default __exports__